import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import { Modal, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import { FaArrowLeft, FaTrash, FaEdit } from "react-icons/fa";
import engineGif from "../image/engine.gif";

const EstimateDetails = ({
  view_data,
  view_details,
  setSwap,
  branch,
  brand,
  model1,
}) => {
  const { globalValue } = useContext(GlobalContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [currentSpare, setCurrentSpare] = useState(null);
  const [currentServiceId, setCurrentServiceId] = useState(null);
  const [newSpare, setNewSpare] = useState({
    spare_id: null,
    spare_name: "",
    quantity: "",
    price: "",
    est_price: "",
    service_id: "",
    brand: "",
    model1: "",
  });
  const [sparelog, setSparelog] = useState([]);
  const [spareOptions, setSpareOptions] = useState([]);
  const [view2, setView2] = useState(false);
  const [serviceId, setServiceId] = useState("");
  const [labour_charge, setLabour_charge] = useState("");
  const [quantity_error, setQuantity_error] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCustomFields, setShowCustomFields] = useState(false);
  const [customRate, setCustomRate] = useState("");
  const [customGST, setCustomGST] = useState("");
  const [customMPR, setCustomMPR] = useState("");
  const [customWarning, setCustomWarning] = useState(false);
  const [currentquantity, setCurrentquantity] = useState("");
  const [services, setServices] = useState([]);
  const [serviceChargeModalOpen, setServiceChargeModalOpen] = useState(false);
  const [serviceChargeServiceId, setServiceChargeServiceId] = useState("");
  const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
  const [serviceChargeList, setServiceChargeList] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState(null);
  const [amountValue, setAmountValue] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [priceError, setPriceError] = useState("");
  const [serviceChargesByServiceId, setServiceChargesByServiceId] = useState(
    {}
  );
  const [selectedDefaultPrice, setSelectedDefaultPrice] = useState(null);
  const [altPrices, setAltPrices] = useState([]);
  const [showAllPrices, setShowAllPrices] = useState(false);

  const spareLog = async (service) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spareLog`,
        { service, estimate_id: view_data.estimate_data.estimate_id, branch },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      setSparelog(response.data);
      const options = response.data.map((spare) => ({
        value: spare["spare_id"],
        label: spare["spare_name"],
        model: spare["model"],
        quantity: spare["quantity"],
        multi_price: spare["multi_price"],
      }));
      setSpareOptions(options);
    } catch (error) {
      console.error("Error fetching spare log:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (modalOpen && modalType !== "delete") {
      spareLog(currentServiceId);
    }
  }, [modalOpen, modalType, currentServiceId]);

  // ✅ FIXED EDIT MODE:
  // - selectedPrice (MRP) = spare.price (the price that was saved/used, e.g. 3000)
  // - est_price            = spare.est_price (the estimated/negotiated price, e.g. 3500)
  // - altPrices            = all other prices EXCEPT the one matching spare.price
  useEffect(() => {
    if (
      modalOpen &&
      modalType === "edit" &&
      currentSpare &&
      spareOptions.length > 0
    ) {
      const spare = currentSpare;

      const selectedOption = spareOptions.find(
        (option) => option.value === spare.spare_id
      );

      if (selectedOption) {
        const selectedSpare = selectedOption.model.find(
          (s) =>
            (s.brand === brand && s.model === model1) ||
            (s.brand === "common" && s.model === "common")
        );

        if (selectedSpare) {
          const keyBrand =
            selectedSpare.brand === "common" ? "common" : brand;
          const keyModel =
            selectedSpare.model === "common" ? "common" : model1;

          const mpEntry = (selectedOption.multi_price || []).find(
            (mp) => mp.brand === keyBrand && mp.model === keyModel
          );

          const mpPrices = Array.isArray(mpEntry?.prices) ? mpEntry.prices : [];
          const inlinePrices = Array.isArray(selectedSpare?.prices)
            ? selectedSpare.prices
            : [];

          // Build union of all available prices including the default
          const defaultPrice = {
            mrp: selectedSpare.mrp,
            gst: selectedSpare.gst,
            rate: selectedSpare.rate,
          };

          const allPrices = [defaultPrice, ...inlinePrices, ...mpPrices];

          // Deduplicate by mrp|gst key
          const seen = new Set();
          const uniqueAllPrices = allPrices.filter((p) => {
            const key = `${p.mrp}|${p.gst}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });

          // ✅ KEY FIX:
          // spare.price = the MRP that was selected/saved (e.g. 3000)
          // Find which price object from uniqueAllPrices matches spare.price

          const matchedPrice = uniqueAllPrices.find((p) => {
            const mrpMatch =
              Math.abs(parseFloat(p.mrp) - parseFloat(spare.mrp || spare.price)) < 0.01;

            const gstMatch =
              Math.abs(parseFloat(p.gst || 0) - parseFloat(spare.gst_value || 0)) < 0.01;

            const rateMatch =
              Math.abs(parseFloat(p.rate || 0) - parseFloat(spare.rate || 0)) < 0.01;

            return mrpMatch && gstMatch && rateMatch;
          });

          // Use matched price if found, otherwise fall back to default
          const activePrice = matchedPrice || defaultPrice;

          // ✅ altPrices = all prices EXCEPT the one currently selected (activePrice)
          const remainingAlt = uniqueAllPrices.filter(
            (p) =>
              !(
                Math.abs(parseFloat(p.mrp) - parseFloat(activePrice.mrp)) < 0.01 &&
                parseFloat(p.gst) === parseFloat(activePrice.gst)
              )
          );

          setSelectedDefaultPrice({
            mrp: activePrice.mrp,
            gst: activePrice.gst,
            rate: activePrice.rate,
          });

          setAltPrices(remainingAlt);

          // ✅ price    = spare.price     → the saved selected MRP (e.g. 3000) shown in "Selected Price" field
          // ✅ est_price = spare.est_price → the saved estimated price (e.g. 3500) shown in "Estimated Price" field
          setNewSpare((prev) => ({
            ...prev,
            price: spare.mrp != null ? parseFloat(spare.mrp).toFixed(2) : parseFloat(spare.price).toFixed(2),
            est_price:
              spare.est_price != null
                ? parseFloat(spare.est_price).toFixed(2)
                : parseFloat(spare.price).toFixed(2),
          }));
        } else {
          // Spare not found for this brand/model — show custom fields
          setShowCustomFields(true);
          setCustomWarning(true);
        }
      }
    }
  }, [spareOptions, modalOpen, modalType]);

  const openModal = (type, serviceId, spare = null) => {
    setModalType(type);
    setCurrentServiceId(serviceId);
    setCurrentSpare(spare);
    setModalOpen(true);
    if (type === "add") {
      setNewSpare({
        spare_id: null,
        spare_name: "",
        quantity: "",
        price: "",
        est_price: "",
        service_id: serviceId,
        brand: "",
        model1: "",
      });
      setAltPrices([]);
      setSelectedDefaultPrice(null);
      setShowAllPrices(false);
      setShowCustomFields(false);
      setCustomGST("");
      setCustomMPR("");
      setCustomRate("");
      setCustomWarning(false);
      setQuantity_error("");
    } else if (type === "edit" && spare) {

      setNewSpare({
        spare_id: spare.spare_id,
        spare_name: spare.spare_name,
        quantity: spare.quantity,
        // ✅ After
        price: spare.mrp != null ? parseFloat(spare.mrp).toFixed(2) : parseFloat(spare.price).toFixed(2), est_price:
          spare.est_price != null
            ? parseFloat(spare.est_price).toFixed(2)
            : parseFloat(spare.price).toFixed(2),
        service_id: serviceId,
        brand: brand,
        model1: model1,
      });

      setShowCustomFields(false);
      setCustomGST("");
      setCustomMPR("");
      setCustomRate("");
      setCustomWarning(false);
      setQuantity_error(spare.quantity);
      setAltPrices([]);
      setSelectedDefaultPrice(null);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentSpare(null);
    setCurrentServiceId(null);
    setShowCustomFields(false);
    setCustomGST("");
    setCustomMPR("");
    setCustomRate("");
    setCustomWarning(false);
    setQuantity_error("");
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      let payload = {
        ...newSpare,
        service_id: currentServiceId,
        estimate_id: view_data.estimate_data.estimate_id,
        is_manual_add: showCustomFields,
        branch: sessionStorage.getItem("branch"),
      };
      payload.est_price = newSpare.est_price;
      if (showCustomFields) {
        payload.gst = customGST;
        payload.mpr = customMPR;
        payload.rate = customRate;
        payload.price = parseFloat(customMPR).toFixed(2);
        payload.est_price = parseFloat(customMPR).toFixed(2);
      }
      let response;
      if (modalType === "add") {
        response = await axios.post(`${globalValue}/addSpare`, payload, {
          headers: { "x-access-token": sessionStorage.getItem("token") },
        });
      } else if (modalType === "edit") {
        response = await axios.post(
          `${globalValue}/editSpare`,
          {
            spare_id: currentSpare.spare_id,
            quantity: newSpare.quantity,
            price: newSpare.price,
            est_price: newSpare.est_price,
            service_id: currentServiceId,
            estimate_id: view_data.estimate_data.estimate_id,
          },
          { headers: { "x-access-token": sessionStorage.getItem("token") } }
        );
      }
      if (response.data === "success") {
        closeModal();
        view_details(view_data.estimate_data.estimate_id);
      } else if (response.data === "failure") {
        Swal.fire({ icon: "warning", title: "Spare already exists" });
        closeModal();
        view_details(view_data.estimate_data.estimate_id);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: error.message || "Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/deleteSpare`,
        {
          spare_id: currentSpare.spare_id,
          estimate_id: view_data.estimate_data.estimate_id,
          service_id: currentServiceId,
          quantity: currentquantity,
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data === "success") {
        closeModal();
        view_details(view_data.estimate_data.estimate_id);
      } else {
        Swal.fire("Error", "Failed to delete the spare.", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong while deleting!", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchDat = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/services`, {
        params: { data: branch, position: "" },
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDat();
  }, []);

  const serviceOptions = services.map((service) => ({
    value: service[1],
    label: service[2],
    labour_charge: service[5],
  }));

  const deleteService = async (estimate_id, service_id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmDelete.isConfirmed) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/del_ser`,
        { estimate_id, service_id },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );

      if (response.data.message === "success") {
        view_details(view_data.estimate_data.estimate_id);
      } else {
        Swal.fire({ icon: "warning", title: response.data.message });
      }
    } catch {
      Swal.fire({ icon: "warning", title: "Service not deleted" });
    } finally {
      setLoading(false);
    }
  };

  const handleservice = async (est_id, service, labour_charge) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/add_service`,
        { est_id, service, labour_charge },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data === "success") {
        setView2(false);
        view_details(view_data.estimate_data.estimate_id);
      } else if (response.data === "failure") {
        setView2(false);
        view_details(view_data.estimate_data.estimate_id);
        Swal.fire({ icon: "warning", title: "Service already exist" });
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchAllServiceCharges = async () => {
    try {
      const chargesData = {};
      for (const service of view_data.services) {
        const response = await axios.post(
          `${globalValue}/getServiceCharges`,
          {
            estimate_id: view_data.estimate_data.estimate_id,
            service_id: service.service_id,
          },
          { headers: { "x-access-token": sessionStorage.getItem("token") } }
        );
        chargesData[service.service_id] = response.data.subcategories || [];
      }
      setServiceChargesByServiceId(chargesData);
    } catch (error) {
      console.error("Error fetching all service charges:", error);
    }
  };

  useEffect(() => {
    if (view_data?.services?.length) {
      fetchAllServiceCharges();
    }
  }, [view_data.services]);

  const saveChargesInline = async (service_id) => {
    try {
      const payload = {
        estimate_id: view_data.estimate_data.estimate_id,
        service_id,
        subcategories: serviceChargesByServiceId[service_id],
      };
      const response = await axios.post(
        `${globalValue}/saveServiceCharges`,
        payload,
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data.success) {
        Swal.fire({ icon: "success", title: "Service charges saved!" });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.data.message || "Could not save service charges.",
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not save service charges.",
      });
    }
  };

  const updateChargeField = (serviceId, index, field, value) => {
    setServiceChargesByServiceId((prev) => {
      const updated = { ...prev };
      updated[serviceId] = [...updated[serviceId]];
      updated[serviceId][index] = {
        ...updated[serviceId][index],
        [field]: value,
      };
      return updated;
    });
  };

  const handleAddCharges = (serviceId) => {
    if (
      !serviceChargesByServiceId[serviceId] ||
      serviceChargesByServiceId[serviceId].length === 0
    ) {
      openServiceChargesModal(serviceId);
    } else {
      Swal.fire("Charges already exist. You can edit them below.", "", "info");
    }
  };

  const fetchSubCategories = async (serviceId) => {
    try {
      const res = await axios.get(`${globalValue}/subcategories`, {
        params: { service_id: serviceId },
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });
      if (res.data.success) {
        setSubCategoriesOptions(
          res.data.subcategories.map((sc) => ({
            value: sc.id,
            label: sc.name,
            amount: sc.amount,
          }))
        );
      } else {
        setSubCategoriesOptions([]);
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not fetch subcategories.",
      });
    }
  };

  const openServiceChargesModal = (serviceId) => {
    setServiceChargeServiceId(serviceId);
    fetchSubCategories(serviceId);
    setServiceChargeList([]);
    setSelectedSubCat(null);
    get_data(view_data.estimate_data.estimate_id, serviceId);
    setAmountValue("");
    setEditIndex(null);
    setServiceChargeModalOpen(true);
  };

  const get_data = async (estimate_id, service_id) => {
    try {
      const response = await axios.post(
        `${globalValue}/getServiceCharges`,
        { estimate_id, service_id },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data) {
        setServiceChargeList(response.data.subcategories || []);
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not fetch service charges.",
      });
    }
  };

  const handleDeleteEntry = async (name, service_id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: `Delete "${name}" from service charges?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirmDelete.isConfirmed) return;
    const updatedList = (serviceChargesByServiceId[service_id] || []).filter(
      (item) => item.name.trim().toLowerCase() !== name.trim().toLowerCase()
    );
    try {
      const payload = {
        estimate_id: view_data.estimate_data.estimate_id,
        service_id,
        subcategories: updatedList,
      };
      const response = await axios.post(
        `${globalValue}/saveServiceCharges`,
        payload,
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data.success) {
        Swal.fire("Deleted!", `"${name}" has been removed.`, "success");
        setServiceChargesByServiceId((prev) => ({
          ...prev,
          [service_id]: updatedList,
        }));
        fetchAllServiceCharges();
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Could not delete entry.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong while deleting!", "error");
      console.error("Delete charge error:", error);
    }
  };

  const saveServiceCharge = async () => {
    if (!selectedSubCat?.label) {
      Swal.fire("Select Sub Category", "", "warning");
      return;
    }
    if (!amountValue) {
      Swal.fire("Enter amount", "", "warning");
      return;
    }

    const nameToCheck = selectedSubCat.label.trim().toLowerCase();
    const isDuplicate = serviceChargeList.some((item, index) => {
      return (
        item.name.trim().toLowerCase() === nameToCheck && index !== editIndex
      );
    });

    if (isDuplicate) {
      Swal.fire(
        "Duplicate Entry",
        "This sub category already exists.",
        "warning"
      );
      return;
    }

    const newEntry = {
      id: selectedSubCat.value || null,
      name: selectedSubCat.label.trim(),
      amount: amountValue,
    };

    let updatedList = [...serviceChargeList];
    if (editIndex !== null) {
      updatedList[editIndex] = newEntry;
      setEditIndex(null);
    } else {
      updatedList.push(newEntry);
    }

    setServiceChargeList(updatedList);
    setSelectedSubCat(null);
    setAmountValue("");

    try {
      const payload = {
        estimate_id: view_data.estimate_data.estimate_id,
        service_id: serviceChargeServiceId,
        subcategories: updatedList,
      };

      const response = await axios.post(
        `${globalValue}/saveServiceCharges`,
        payload,
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Service charges saved successfully!",
        });
        fetchAllServiceCharges();
        setServiceChargeModalOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.data.message || "Could not save service charges.",
        });
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Could not save service charges.",
      });
    }
  };

  if (!view_data.estimate_data) {
    return <div>Loading customer data...</div>;
  }

  return (
    <div className="space-y-6 overflow-auto">
      <div className="p-4 bg-white rounded shadow-xl border border-gray-300 relative">
        <div className="flex gap-6">
          <button
            onClick={() => {
              view_details(view_data.estimate_data.estimate_id);
              setSwap(true);
            }}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
          >
            <FaArrowLeft className="w-4 h-4" />
          </button>
          <h2 className="text-xl font-semibold">Customer Information</h2>
        </div>
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
          <div>
            <strong>Customer:</strong> {view_data.estimate_data.customer_name}
          </div>
          <div>
            <strong>Estimate ID:</strong> {view_data.estimate_data.estimate_id}
          </div>
          <div>
            <strong>Date:</strong>{" "}
            {new Date(view_data.estimate_data.date).toLocaleDateString(
              "en-GB",
              { day: "2-digit", month: "2-digit", year: "numeric" }
            )}
          </div>
        </div>
        {view_data.estimate_data.status === "0" && (
          <>
            <button
              onClick={() => {
                setView2(true);
                setServiceId("");
                setLabour_charge("");
              }}
              className="hidden md:block absolute right-2 top-2 bg-blue-500 rounded-sm px-4 py-2 text-white"
            >
              Add Service
            </button>
            <button
              onClick={() => {
                setView2(true);
                setServiceId("");
                setLabour_charge("");
              }}
              className="md:hidden rounded-xl absolute right-2 top-2 bg-blue-500 p-2 text-white text-3xl font-bold"
            >
              +
            </button>
          </>
        )}
      </div>
      <Modal show={view2} size="4xl" onClose={() => setView2(false)}>
        <Modal.Header>Add Service</Modal.Header>
        <Modal.Body>
          <form className="space-y-6">
            <div>
              <Label htmlFor="serviceId" value="Select Service" />
              <Select
                id="serviceId"
                options={serviceOptions}
                value={serviceOptions.find((opt) => opt.value === serviceId)}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setServiceId(selectedOption.value);
                    setLabour_charge(selectedOption.labour_charge || "");
                  } else {
                    setServiceId("");
                    setLabour_charge("");
                  }
                }}
                placeholder="Search and select service..."
                isSearchable
                isClearable
                className="mt-1"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              <div className="mt-4">
                <Label htmlFor="service_amount" value="Labour Charge" />
                <input
                  id="service_amount"
                  type="number"
                  className="mt-1 p-2 w-full border rounded"
                  value={labour_charge}
                  onChange={(e) => setLabour_charge(e.target.value)}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button_submit
            onClick={() =>
              handleservice(
                view_data.estimate_data.estimate_id,
                serviceId,
                labour_charge
              )
            }
            data="Add"
            type="submit"
            aditional="ms-auto"
          />
        </Modal.Footer>
      </Modal>
      {view_data.services.map((service, index) => (
        <div
          key={index}
          className="p-6 bg-white rounded-lg shadow-md border border-gray-300"
        >
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="text-xl font-medium">{service.service_name}</h3>
              <span className="text-gray-500">
                Service ID: {service.service_id}
              </span>
            </div>
            {view_data.estimate_data.status === "0" && (
              <div className="flex gap-2">
                <button
                  onClick={() => openServiceChargesModal(service.service_id)}
                  className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
                >
                  Add Service Charges
                </button>
                <button
                  onClick={() => {
                    openModal("add", service.service_id);
                    setQuantity_error(6);
                  }}
                  className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Add Spare
                </button>
                <button
                  onClick={() =>
                    deleteService(
                      view_data.estimate_data.estimate_id,
                      service.service_id
                    )
                  }
                  className="px-4 py-2 bg-red-500 text-white rounded hover:bg-green-600"
                >
                  <FaTrash />
                </button>
              </div>
            )}
          </div>
          {service.spares.length > 0 ? (
            <>
              <div>
                <div className="overflow-auto max-h-64 border rounded">
                  <table className="min-w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-100 text-gray-600">
                        <th className="p-3 border border-gray-300">
                          Spare Name
                        </th>
                        <th className="p-3 border border-gray-300">Quantity</th>
                        <th className="p-3 border border-gray-300">MRP</th>
                        <th className="p-3 border border-gray-300">Price</th>
                        {view_data.estimate_data.status === "0" && (
                          <th className="p-3 border border-gray-300 w-36">
                            Actions
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {service.spares.map((spare, spareIndex) => (
                        <tr
                          key={spareIndex}
                          className="text-gray-700 hover:bg-gray-50"
                        >
                          <td className="p-3 border border-gray-300">
                            {spare.spare_name}
                          </td>
                          <td className="p-3 border border-gray-300">
                            {spare.quantity}
                          </td>
                          <td className="p-3 border border-gray-300">
                            Rs.{" "}
                            {spare.mrp != null && !isNaN(spare.mrp)
                              ? Number(spare.mrp).toFixed(2)
                              : "0.00"}
                          </td>
                          <td className="p-3 border border-gray-300">
                            Rs. {spare.price.toFixed(2)}
                          </td>
                          {view_data.estimate_data.status === "0" && (
                            <td className="p-3 border border-gray-300 flex justify-center gap-2">
                              <button
                                onClick={() =>
                                  openModal("edit", service.service_id, spare)
                                }
                                className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => {
                                  openModal(
                                    "delete",
                                    service.service_id,
                                    spare
                                  );
                                  setCurrentquantity(spare.quantity);
                                }}
                                className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                              >
                                Delete
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <p className="text-gray-500">
              No spares associated with this service.
            </p>
          )}
          <div className="mt-4">
            <h4 className="font-semibold mb-2">Service Charges</h4>
            {serviceChargesByServiceId[service.service_id] &&
              serviceChargesByServiceId[service.service_id].length ? (
              <div>
                <table className="min-w-full border">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border p-2">Sub Category</th>
                      <th className="border p-2">Amount</th>
                      <th className="border p-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {serviceChargesByServiceId[service.service_id].map(
                      (charge, idx) => (
                        <tr key={idx}>
                          <td className="border p-2">
                            <input
                              type="text"
                              value={charge.name}
                              onChange={(e) =>
                                updateChargeField(
                                  service.service_id,
                                  idx,
                                  "name",
                                  e.target.value
                                )
                              }
                              className="w-full border p-1"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="number"
                              value={charge.amount}
                              onChange={(e) =>
                                updateChargeField(
                                  service.service_id,
                                  idx,
                                  "amount",
                                  e.target.value
                                )
                              }
                              className="w-full border p-1"
                            />
                          </td>
                          <td className="border p-2">
                            <button
                              onClick={() => {
                                handleDeleteEntry(
                                  charge.name,
                                  service.service_id
                                );
                              }}
                              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
                <button
                  onClick={() => saveChargesInline(service.service_id)}
                  className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Save Charges
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
      <Modal show={modalOpen} onClose={closeModal}>
        <Modal.Header>
          {modalType === "add"
            ? "Add Spare"
            : modalType === "edit"
              ? "Edit Spare"
              : "Delete Spare"}
        </Modal.Header>
        <Modal.Body>
          {modalType !== "delete" ? (
            <>
              {modalType === "add" && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Spare Name
                  </label>
                  <Select
                    options={spareOptions}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(selectedOption) => {
                      const selectedSpare = selectedOption.model.find(
                        (spare) =>
                          (spare.brand === brand && spare.model === model1) ||
                          (spare.brand === "common" &&
                            spare.model === "common")
                      );

                      const isCommonSpare =
                        selectedSpare?.brand === "common" &&
                        selectedSpare?.model === "common";

                      if (
                        !selectedSpare ||
                        selectedSpare.quantity === undefined ||
                        selectedSpare.quantity === null
                      ) {
                        setShowCustomFields(true);
                        setCustomWarning(true);
                        setNewSpare({
                          ...newSpare,
                          spare_id: selectedOption?.value || null,
                          spare_name: selectedOption?.label || "",
                          price: "",
                          service_id: currentServiceId,
                          brand: isCommonSpare ? "common" : brand,
                          model1: isCommonSpare ? "common" : model1,
                        });
                        setSelectedDefaultPrice(null);
                        setAltPrices([]);
                        setQuantity_error(0);
                      } else {
                        setShowCustomFields(false);
                        setCustomWarning(false);
                        const calculatedPrice = parseFloat(selectedSpare.mrp);
                        setNewSpare({
                          ...newSpare,
                          spare_id: selectedOption?.value || null,
                          spare_name: selectedOption?.label || "",
                          price: calculatedPrice.toFixed(2),
                          est_price: calculatedPrice.toFixed(2),
                          service_id: currentServiceId,
                          brand: isCommonSpare ? "common" : brand,
                          model1: isCommonSpare ? "common" : model1,
                        });
                        setSelectedDefaultPrice({
                          mrp: selectedSpare.mrp,
                          gst: selectedSpare.gst,
                          rate: selectedSpare.rate,
                        });
                        const keyBrand = isCommonSpare ? "common" : brand;
                        const keyModel = isCommonSpare ? "common" : model1;
                        const mpEntry = (
                          selectedOption.multi_price || []
                        ).find(
                          (mp) =>
                            mp.brand === keyBrand && mp.model === keyModel
                        );
                        const mpPrices = Array.isArray(mpEntry?.prices)
                          ? mpEntry.prices
                          : [];
                        const inlinePrices = Array.isArray(
                          selectedSpare?.prices
                        )
                          ? selectedSpare.prices
                          : [];
                        const union = [
                          ...(inlinePrices || []),
                          ...(mpPrices || []),
                        ];
                        const seen = new Set();
                        const unique = union.filter((p) => {
                          const key = `${p.mrp}|${p.gst}`;
                          if (seen.has(key)) return false;
                          seen.add(key);
                          return true;
                        });
                        const filtered = unique.filter(
                          (p) =>
                            !(
                              p.mrp == selectedSpare.mrp &&
                              p.gst == selectedSpare.gst
                            )
                        );
                        setAltPrices(filtered);
                        setQuantity_error(selectedSpare.quantity);
                        setCustomRate("");
                        setCustomGST("");
                        setCustomMPR("");
                      }
                    }}
                    value={spareOptions.find(
                      (option) => option.label === newSpare.spare_name
                    )}
                    placeholder="Select Spare Name"
                    className="z-50"
                  />
                  {customWarning && (
                    <p className="text-red-600 mt-1">
                      Spare is not available for this vehicle. Please enter
                      GST%, MRP and Rate manually.
                    </p>
                  )}
                  {showCustomFields && (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GST %
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          className="mt-1 p-2 w-full border rounded"
                          value={customGST}
                          onChange={(e) => setCustomGST(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          MRP
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          className="mt-1 p-2 w-full border rounded"
                          value={customMPR}
                          onChange={(e) => setCustomMPR(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Rate
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          className="mt-1 p-2 w-full border rounded"
                          value={customRate}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            setCustomRate(value);
                            if (value > customMPR) {
                              setPriceError("Rate cannot be higher than MRP");
                            } else {
                              setPriceError("");
                            }
                          }}
                        />
                        {priceError !== "" && (
                          <p className="text-red-600 mt-1">{priceError}</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Quantity
                </label>
                <input
                  type="number"
                  min="0"
                  className="mt-1 p-2 w-full border rounded"
                  value={newSpare.quantity}
                  onChange={(e) =>
                    setNewSpare({
                      ...newSpare,
                      quantity: e.target.value,
                      service_id: currentServiceId,
                    })
                  }
                />
              </div>

              {!customWarning && (
                <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Selected Price (MRP)
                    </label>
                    <input
                      type="number"
                      className="mt-1 p-2 w-full border rounded bg-gray-100"
                      value={newSpare.price}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Estimated Price
                    </label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="mt-1 p-2 w-full border rounded"
                      value={newSpare.est_price}
                      onChange={(e) =>
                        setNewSpare({ ...newSpare, est_price: e.target.value })
                      }
                    />
                  </div>
                </div>
              )}

              {/* ✅ Available Prices shown for both add and edit modes */}
              {!customWarning && altPrices.length > 0 && (
                <div className="mt-2">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-gray-700">
                      Available Prices
                    </p>
                    {altPrices.length > 6 && (
                      <button
                        type="button"
                        className="text-xs text-blue-600 hover:text-blue-800"
                        onClick={() => setShowAllPrices(!showAllPrices)}
                      >
                        {showAllPrices ? "Show less" : "Show more"}
                      </button>
                    )}
                  </div>
                  <div className="mt-2 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                    {(showAllPrices ? altPrices : altPrices.slice(0, 6)).map(
                      (p, idx) => {
                        const rate = (
                          parseFloat(p.mrp) /
                          (1 + (parseFloat(p.gst) || 0) / 100)
                        ).toFixed(2);
                        return (
                          <button
                            key={`${p.mrp}-${p.gst}-${idx}`}
                            type="button"
                            className="px-2 py-1 border rounded text-xs bg-white hover:bg-blue-50 flex flex-col items-start"
                            onClick={() => {
                              // ✅ When user picks an alt price:
                              // - Move the current selectedDefaultPrice back into altPrices
                              // - Set the chosen price as the new selectedDefaultPrice
                              // - Update newSpare.price = chosen.mrp (Selected Price / MRP)
                              // - Keep newSpare.est_price as-is (user can edit it freely)
                              const currentDefault = selectedDefaultPrice;
                              const chosen = p;

                              const newAltRaw = altPrices.filter(
                                (_, i) => i !== idx
                              );
                              if (currentDefault) newAltRaw.push(currentDefault);

                              const seen2 = new Set();
                              const newAlt = newAltRaw.filter((x) => {
                                const key = `${x.mrp}|${x.gst}`;
                                if (seen2.has(key)) return false;
                                seen2.add(key);
                                return true;
                              });

                              setSelectedDefaultPrice({
                                mrp: chosen.mrp,
                                gst: chosen.gst,
                                rate: chosen.rate,
                              });
                              setAltPrices(newAlt);

                              // ✅ Only update price (MRP), NOT est_price
                              // so the user's manually edited est_price is preserved
                              setNewSpare((prev) => ({
                                ...prev,
                                price: parseFloat(chosen.mrp).toFixed(2),
                                // est_price intentionally NOT overwritten here
                                // so user's custom est_price stays intact
                              }));
                            }}
                          >
                            <span className="font-semibold">MRP ₹{p.mrp}</span>
                            <span className="text-gray-600">GST {p.gst}%</span>
                            <span className="text-gray-500">Rate ₹{rate}</span>
                          </button>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div>
              <p className="text-gray-700">
                Are you sure you want to delete this spare?
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex flex-col md:flex-row justify-between w-full gap-4">
            <div className="flex gap-3">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-300 text-white rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={modalType === "delete" ? handleDelete : handleSave}
                disabled={
                  modalType !== "delete" &&
                  (!newSpare.quantity ||
                    (!showCustomFields && !newSpare.price) ||
                    newSpare.quantity <=0 ||
                    (showCustomFields &&
                      (!customGST || !customMPR || !customRate)) ||
                    (modalType === "add" && !newSpare.spare_id))
                }
                className={`px-4 py-2 text-white rounded ${modalType === "delete"
                  ? "bg-red-500 hover:bg-red-600"
                  : "bg-blue-500 hover:bg-blue-600"
                  } ${modalType !== "delete" &&
                    (!newSpare.quantity ||
                      (!showCustomFields && !newSpare.price) ||
                      newSpare.quantity <=0 ||
                      (showCustomFields &&
                        (!customGST || !customMPR || !customRate)) ||
                      (modalType === "add" && !newSpare.spare_id))
                    ? "bg-gray-300 cursor-not-allowed"
                    : ""
                  }`}
              >
                {modalType === "delete" ? "Delete" : "Save"}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={serviceChargeModalOpen}
        onClose={() => setServiceChargeModalOpen(false)}
        size="5xl"
      >
        <Modal.Header>Add Service Charges</Modal.Header>
        <Modal.Body>
          <div className="space-y-4">
            <div>
              <Label value="Select / Add Sub Category" />
              <Select
                options={subCategoriesOptions}
                value={selectedSubCat}
                onChange={(opt) => {
                  setSelectedSubCat(opt);
                  if (opt?.amount) {
                    setAmountValue(opt.amount);
                  } else {
                    setAmountValue("");
                  }
                }}
                isClearable
                isSearchable
                placeholder="Select or type to add new"
                onInputChange={(input, action) => {
                  if (action.action === "input-change" && input) {
                    setSelectedSubCat({ value: null, label: input });
                    setAmountValue("");
                  }
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>
            <div>
              <Label value="Amount" />
              <input
                type="number"
                value={amountValue}
                onChange={(e) => setAmountValue(e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
            onClick={saveServiceCharge}
          >
            Save
          </button>
          <button
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            onClick={() => setServiceChargeModalOpen(false)}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EstimateDetails;
